import { cloneDeep } from "lodash";
/** 页面策略新增数据格式化 */
export const formatAddData = data => {
  const cloneData = cloneDeep(data);
  const relationRequests = cloneData.cardIds.map(item => {
    if (item.top !== undefined) {
      return {
        cardId: Number(item.id),
        top: item.top,
        topStartTime: item.topStartTime,
        topEndTime: item.topEndTime
      };
    } else {
      return {
        cardId: Number(item.id),
        top: false
      };
    }
  });
  cloneData.relationRequests = relationRequests;
  /** 如果渠道为白名单或黑名单，需要处理渠道ids */
  if (cloneData.channelType == 2 || cloneData.channelType == 3) {
    const appIds = cloneData.channel.ids.split(",").map(item => Number(item));
    cloneData.appIds = appIds;
  } else {
    cloneData.appIds = [0];
  }
  delete cloneData.channel;

  cloneData.platforms = cloneData.platforms.map(item => {
    if (item.platform === "Android") {
      item.platformType = 1;
    } else if (item.platform === "IOS") {
      item.platformType = 2;
    } else if (item.platform === "小程序") {
      item.platformType = 6;
    } else if (item.platform === "鸿蒙") {
      item.platformType = 8;
    }
    /** 处理版本号 如果传的是0 或者 '' 都转为0 */
    if (!item.minClientVersion) {
      item.minClientVersion = 0;
    }
    if (!item.maxClientVersion) {
      item.maxClientVersion = 0;
    }
    delete item.platform;
    return item;
  });

  cloneData.screenCastConfigId = cloneData.screenConfig
  cloneData.uidStr = cloneData.uid;
  return cloneData;
};

/** 编辑时数据回填格式化 */
export const formatEditData = data => {
  const cloneData = cloneDeep(data);
  /** 渠道类型 */
  const channelType = cloneData.thirdPartyApps[0].channelType;
  if (channelType == 2 || channelType == 3) {
    cloneData.channelType = Number(channelType); // 保持原有的 channelType（2 或 3）
    const cardIds = cloneData.appCards.map(item => item);
    cloneData.cardIds = cardIds;
    const channel = {
      ids: "",
      names: ""
    };
    channel.ids = cloneData.thirdPartyApps
      .map(item => item.channelId)
      .join(",");
    channel.names = cloneData.thirdPartyApps
      .map(item => item.channelName)
      .join(",");
    cloneData.channel = channel;
    cloneData.appIds = cloneData.thirdPartyApps.map(item => {
      return `[${item.channelId}] ${item.channelName}`;
    });
  } else {
    cloneData.channelType = 1;
    cloneData.appIds = "";
    const cardIds = cloneData.appCards.map(item => item);
    cloneData.cardIds = cardIds;
    const channel = {
      ids: "",
      names: ""
    };
    cloneData.channel = channel;
  }

  cloneData.platforms = cloneData.platforms.map(item => {
    if (item.platformType === 1) {
      item.platform = "Android";
    } else if (item.platformType === 2) {
      item.platform = "IOS";
    } else if (item.platformType === 6) {
      item.platform = "小程序";
    } else if (item.platformType === 8) {
      item.platform = "鸿蒙";
    }
    delete item.platformType;
    return item;
  });
  return cloneData;
};
